export default "__VITE_ASSET__D1KUGZid__"